/**
 * Presentation formatters for reviews, ratings, and quantities.
 */

export const formatReviewCount = (count: number): string => {
  if (count === 1) return '1 review'
  return `${count} reviews`
}

export const formatRating = (rating: number): string => {
  return rating.toFixed(1)
}

/**
 * Clean card meta string for a kitchen or dish.
 * Displays "New" when unrated or without reviews,
 * and "★ 4.2 · 3 reviews" / "★ 5.0 · 1 review" when rated.
 */
export const formatRatingMeta = (rating: number, reviewCount?: number): string => {
  if (!rating || rating <= 0 || (reviewCount !== undefined && reviewCount <= 0)) {
    return 'New'
  }
  const formattedRating = `★ ${rating.toFixed(1)}`
  if (reviewCount !== undefined && reviewCount > 0) {
    return `${formattedRating} · ${formatReviewCount(reviewCount)}`
  }
  return formattedRating
}
